import React from 'react';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { DropDownChonLoaiDonThu, DropDownChonNguonDon } from 'components/tt-forms';
import { InputTuKhoa, DropDown } from 'components/tt-forms/common';
import { DuLieuHeThong } from 'api';
import { isEmpty } from 'lodash';

let classNames = require('classnames');

class FormSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tuKhoa: '',
      nguonDon: '',
      phanLoaiDon: '',
      loaiThongTinDon: '',
      searching: this.props.disabled,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false,
      listLoaiThongTinDon: []
    };
  }

  componentDidMount() {
    this.getListLoaiThongTinDon();
    let state = this.state;
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    state.tuKhoa = data.tuKhoa || '';
    if (data.advanceSearch) {
      state.nguonDon = data.nguonDon || '';
      state.phanLoaiDon = data.phanLoaiDon || '';
    }
    this.setState(state);
  }

  getListLoaiThongTinDon() {
    DuLieuHeThong.actions.getLoaiThongTinDon.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listLoaiThongTinDon: res.data
        });
      }
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.setState({doSearch: true});
    this.props.handleSearch(this.state, e);
  }

  cancel(e) {
    this.props.onCancel(e);
  }

  handleChange(name, e) {
    this.setState({[name]: e.target.value});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetForm) {
      this.resetData();
    } else {
      this.setState({
        searching: nextProps.disabled,
        doSearch: nextProps.search
      });
    }
  }

  resetData() {
    this.setState({
      tuKhoa: '',
      nguonDon: '',
      phanLoaiDon: '',
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    });
  }

  render() {
    let classes = ['btn-green', 'tt-search'];
    if (this.state.searching) {
      classes.push('btn-disable');
    }
    if (this.state.doSearch) {
      classes.push('btn-loading');
    }
    let classesInput = [];
    if (this.props.advanceSearch) {
      classesInput.push('input-20');
    } else {
      classesInput.push('input-show-group');
    }
    let inputClasses = classNames(classesInput);
    let btnClasses = classNames(classes);
    return (
      <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
        <InputTuKhoa
          onChange={this.handleChange.bind(this, 'tuKhoa')}
          value={this.state.tuKhoa}
          channel="formTaoDon" className={inputClasses} />
        <DropDownChonNguonDon exceptNguonDon={this.props.exceptNguonDon} selectedValue={this.state.nguonDon} onChange={this.handleChange.bind(this, 'nguonDon')} className="input-20" />
        <DropDownChonLoaiDonThu selectedValue={this.state.phanLoaiDon} onChange={this.handleChange.bind(this, 'phanLoaiDon')} className="input-20" isDonCu={true} />
        <DropDown
          className="input-20"
          label="Loại thông tin đơn"
          bindValidator={this}
          channel="formTaoDon"
          require={false}
          options={this.state.listLoaiThongTinDon}
          selectedValue={this.state.loaiThongTinDon}
          placeholder
          keyName="giaTri"
          valueName="ten"
          onChange={this.handleChange.bind(this, 'loaiThongTinDon')}
        />
        <div className="btn-wrap-20">
          <Button className={btnClasses} text="Tìm kiếm" type="submit" disabled={this.state.searching ? 'disabled' : ''} />
        </div>
        <div className="input-20 ps-huytimkiem">
          <Link className={classNames({
            'disable-super-search btn-disable-transparent': this.state.tableLoading,
            'disable-super-search': !this.state.tableLoading
          })} onClick={this.cancel.bind(this)}><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
        </div>
      </form>
    );
  }
}

FormSearch.defaultProps = {
  validators: {},
  handleSearch: function () {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false
}

export default FormSearch;



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/list-handle-letters-search/FormSearch.jsx